<template>
    <div :class="getTabClass()">
        <div :class="getTabHeaderClass()">
            <button
                :id="ariaId + '_header'"
                class="p-accordion-header-link"
                :aria-expanded="isTabActive() ? 'true' : 'false'"
                :tabindex="disabled ? null : '0'"
                :aria-controls="ariaId + '_content'"
                :aria-label="ariaLabel || header"
                @click="onTabClick"
            >
                <span :class="isTabActive() ? getHeaderCollapseIcon() : getHeaderExpandIcon()"></span>
                <span v-if="header" class="p-accordion-header-text">{{ header }}</span>
                <slot name="header"></slot>
            </button>
        </div>
        <transition name="p-toggleable-content">
            <div
                v-show="isTabActive()"
                :id="ariaId + '_content'"
                class="p-toggleable-content"
                role="region"
                :aria-labelledby="ariaId + '_header'"
            >
                <div class="p-accordion-content">
                    <slot></slot>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import UniqueComponentId from 'primevue/utils/UniqueComponentId';
import DomHandler from 'primevue/utils/DomHandler';

export default {
    props: {
        // eslint-disable-next-line
        header: null,
        disabled: Boolean,
        ariaLabel: {
            type: String,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            index: null,
        };
    },
    computed: {
        ariaId() {
            return UniqueComponentId();
        },
    },
    created() {
        this.$parent.$children.forEach((child, i) => {
            if (child === this) this.index = i;
        });
    },
    methods: {
        onTabClick(event) {
            if (!this.disabled) {
                this.$parent.onToggle(event, this, DomHandler.index(this.$el), this.isTabActive());
            }
        },
        isTabActive() {
            const activeArray = this.$parent.d_activeIndex;
            return this.$parent.multiple ? activeArray && activeArray.includes(this.index) : this.index === activeArray;
        },
        getTabClass() {
            return ['p-accordion-tab', { 'p-accordion-tab-active': this.isTabActive() }];
        },
        getTabHeaderClass() {
            return ['p-accordion-header', { 'p-highlight': this.isTabActive(), 'p-disabled': this.disabled }];
        },
        getHeaderCollapseIcon() {
            return ['p-accordion-toggle-icon pi', this.$parent.collapseIcon];
        },
        getHeaderExpandIcon() {
            return ['p-accordion-toggle-icon pi', this.$parent.expandIcon];
        },
    },
};
</script>
